import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  Typography, Dialog, DialogTitle, DialogContent, DialogActions, Card, CardContent,
  Button, TextField, Select, MenuItem, Grid, Snackbar, Alert, DialogContentText, Box,
  Input,
} from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import { useTheme } from '@mui/material/styles';
import { getProbe, deleteProbe, getProbeTypes, getProbeInventoryList, addProbe, modifyProbe, importFile, getProbeModels } from "apis/ProbeInventoryApis";
import borders from "assets/mavric-theme/base/borders";
import useMediaQuery from '@mui/material/useMediaQuery';
import ProbeInventoryTable from './ProbeInventoryTable';
import { CircularProgress } from "@mui/material";
import { isEmptyObject, validateName, removeAllSpaces } from "common_utils/utils";
const { primary, secondary, text, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;

export default function ProbeInventoryView() {
  const dispatch = useDispatch();
  const MyStateRole = useSelector(state => state.role);
  const [probeInventory, setProbeInventory] = useState(null);
  const [probeSerialNum, setProbeSerialNum] = useState("");
  const [error, setError] = useState(false);
  const [isProbeFound, setIsProbeFound] = useState(null);
  const [openAddProbeDialog, setOpenAddProbeDialog] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const [probeNum, setProbeNum] = useState("");
  const [modelName, setModelName] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [softwareVersion, setSoftwareVersion] = useState("");
  const [mainBoardRev, setMainBoardRev] = useState("");
  const [custInfo, setCustInfo] = useState("");
  const [soNumber, setSoNum] = useState("");
  const [probeTypes, setProbeTypeList] = useState([]);
  const [probeType, setProbeType] = useState("iSeries (RM-AUDIO-ONLY)");
  const [probeInventoryData, setProbeInventoryData] = useState([]);
  const [formData, setFormData] = useState({
    probe_type: "",
    serial_number: "",
    model_name: "",
    mac_address: "",
    software_version: "",
    main_board_rev: "",
    customer_info: "",
    so_number: ""
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [pageAlertType, setPageAlertType] = useState("error");
  const [alertState, setAlertState] = useState({ openAlert: false, alertSeverity: "error", alertMessage: "", vertical: 'bottom', horizontal: 'left' });
  const { openAlert, alertSeverity, alertMessage, vertical, horizontal } = alertState;
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteMessageConfirm, setDeleteMessageConfirm] = useState("");
  const [deleteMessageConfirmTitle, setDeleteMessageConfirmTitle] = useState("");
  const [deleteAlertMsg, setDeleteAlertMsg] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [probeModels, setProbeModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState('');
  const [supportedTypes, setSupportedTypes] = useState([]);

  const getProbeData = (probeInfo) => {
    return new Promise((resolve, reject) => {
      getProbe(probeInfo).then((response) => {
        // console.log("Response:", response);
        setProbeInventory(response);
        resolve(response);
      }).catch((error) => {
        console.error('Error fetching:', error);
        setProbeInventory(null);
        reject(error);
      });
    });
  };

  const getProbeTypesData = () => {
    return new Promise((resolve, reject) => {
      getProbeTypes().then((response) => {
        // console.log("Response:", response.payload);
        setProbeTypeList(response.payload);
        resolve(response);
      }).catch((error) => {
        console.error('Error fetching:', error);
        setProbeInventory(null);
        reject(error);
      });
    });
  };

  // const getProbeModelsData = () => {
  //   return new Promise((resolve, reject) => {
  //     getProbeModels().then((res) => {
  //       console.log("Response from ProbeModelsData:---->", res);
  //       setProbeModels(res || []);
  //       resolve(res);
  //     }).catch((error) => {
  //       console.error("Something went wrong:", error);
  //       setProbeModels([]);
  //       reject(error);
  //     })
  //   })
  // }

  const getProbeModelsData = async () => {
    try {
      const res = await getProbeModels();
      // console.log("Response from ProbeModelsData:---->", res);
      const models = res.payload || [];
      setProbeModels(models);
      // setProbeModels(Array.isArray(res) ? res : []);
      // setProbeModels(res);
      return models;
    } catch (error) {
      console.error("Something went wrong:", error);
      setProbeModels([]);
      throw error;
    }
  };

  // const getProbeInventoryData = () => {
  //   try {
  //     setLoading(true);
  //     return new Promise(async (resolve, reject) => {
  //       await getProbeInventoryList().then((response) => {
  //         setLoading(true);
  //         console.log("Response:", response);
  //         if (response) {
  //           setProbeInventoryData(response.payload);
  //           resolve(response);
  //         } else {
  //           setProbeInventoryData(null);
  //           setLoading(false);
  //         }
  //       }).catch((error) => {
  //         console.error('Error fetching data consumption:', error);
  //         setProbeInventoryData(null);
  //         reject(error);
  //       });
  //     });
  //   } catch (error) {
  //     console.error('Failed to fetch data:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getProbeInventoryData = async () => {
    setLoading(true);
    try {
      const response = await getProbeInventoryList();
      // console.log("Response:", response);

      if (response.payload && Array.isArray(response.payload)) {
        setProbeInventoryData(response.payload);
      } else {
        setProbeInventoryData([]);
      }

      return response;
    } catch (error) {
      console.error('Error fetching probe inventory data:', error);
      setProbeInventoryData([]);
      throw error; // rethrow if caller needs to handle it
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProbeTypesData();
    getProbeInventoryData();
    getProbeModelsData();

  }, []);


  // const handleSearch = async () => {
  //   try {
  //     setHasSearched(true);
  //     if(probeSerialNum != null) {
  //       setIsSearching(true);
  //       let result = await getProbeData(probeSerialNum);
  //       //  setHasSearched(true);
  //       console.log("Result:", result);
  //       if(result.code === 200){
  //         setHasSearched(true);
  //         // setIsProbeFound(false);
  //         setIsProbeFound(true);
  //         setIsEditMode(true);
  //         setOpenAddProbeDialog(true);
  //         setFormData(result.payload);
  //         setProbeType(result.payload.probe_type);
  //       } else if(result.code === 404){
  //         // setIsProbeFound(true);
  //         setIsProbeFound(false);
  //         setIsEditMode(false);
  //       } else {
  //         // setIsProbeFound(true);
  //         setHasSearched(true);
  //         setIsProbeFound(false);
  //         setIsEditMode(false);
  //       }
  //     } else setError(true);
  //   } catch (error) {
  //     console.error("Error fetching probe data:", error);
  //     // setIsProbeFound(true);
  //     setIsProbeFound(false);
  //     setIsEditMode(false);
  //   }
  // };

  const handleSearch = async () => {
    try {
      if (!probeSerialNum) {
        setError(true);
        setHasSearched(false);
        return;
      }
      setIsSearching(true);
      const result = await getProbeData(probeSerialNum);

      if (result.code === 200) {
        setIsProbeFound(true);
        setHasSearched(true);
        setIsEditMode(true);
        setOpenAddProbeDialog(true);
        setFormData(result.payload);
        setProbeType(result.payload.probe_type);
      } else {
        setIsProbeFound(false);
        setHasSearched(true);
        setIsEditMode(false);
      }
    } catch (error) {
      console.error("Search error:", error);
      setIsProbeFound(false);
      setHasSearched(true);
      setIsEditMode(false);
    } finally {
      setIsSearching(false);
    }
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    // console.log("newVal::",newValue);
    // Check if the value is empty or a valid number
    if (newValue !== '' || /^\d+$/.test(newValue) || newValue.length > 0 && newValue.isEmptyObject()) {
      setProbeSerialNum(newValue);
      setError(false);
    } else {
      setProbeSerialNum("");
      setError(true);
      setHasSearched(false)
    }
  };

  const handleImportFile = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file); // Adjust 'file' to match your backend field name

    try {
      const response = await importFile(formData);
      if (response.code === 200) {
        getProbeInventoryData();
      }
      // console.log(response);
      setFile("");
      fileInputRef.current = "";
      console.log(`Success: ${response.message || 'File uploaded'}`);
      setPageAlertType("success");
      setDeleteAlertMsg(`Success : File uploaded`);
    } catch (error) {
      console.log(`Error: ${error.response.message || error.message}`);
      setPageAlertType("error");
      setDeleteAlertMsg(`Error: File not uploaded`);
    }
  };

  const handleImportChage = (event) => {
    // console.log(event.target.value);
    const selectedFile = event.target.files[0];
    console.log("selectedFile::", selectedFile);
    if (selectedFile && selectedFile.name.endsWith('.xlsx')) {
      setFile(selectedFile);
    } else {
      console.log('Please select a valid .xlsx file.');
      setPageAlertType("error");
      setDeleteAlertMsg(`Please select a valid .xlsx file.`);
    }
  };

  const handleAddNew = () => {
    setOpenAddProbeDialog(true);
    setProbeNum(probeSerialNum);
  };


  const emptyForm = {
    model_name: '',
    probe_type: '',
    serial_number: '',
    mac_address: '',
    software_version: '',
    main_board_rev: '',
    customer_info: '',
    so_number: ''
  }

  const handleUpdateCloseDialog = () => {
    setOpenAddProbeDialog(false);
    setIsProbeFound(false);
    setHasSearched(false)
    setProbeSerialNum("");
    setFormData(emptyForm);
    setSupportedTypes([]);
    resetForm();
  };

  const resetForm = () => {
    setProbeNum(null);
    setModelName(null);
    setMacAddress(null);
    setSoftwareVersion(null);
    setSoNum(null);
    setMainBoardRev(null);
    setCustInfo(null);
  }

  // const handleFormChange = (e) => {
  //   switch (e.target.name) {
  //     case 'probeNum':
  //       let probeNum = e.target.value;
  //       probeNum = removeAllSpaces(probeNum)
  //       setProbeNum(probeNum);
  //       // if(!isEditMode){
  //         formData.probeNum = probeNum;
  //         setFormData(formData);
  //       // }
  //       break; 
  //     case 'modelName':
  //       let modelName = e.target.value;
  //       modelName = removeAllSpaces(modelName)
  //       setModelName(modelName);
  //       formData.model_name = modelName;
  //       setFormData(formData);
  //       break;
  //     case 'macAddress':
  //       let macAddress = e.target.value;
  //       macAddress = removeAllSpaces(macAddress);
  //       setMacAddress(macAddress);
  //       formData.mac_address = macAddress;
  //       setFormData(formData);
  //       break;
  //     case 'softwareVersion':
  //       let softwareVersion = e.target.value;
  //       softwareVersion = removeAllSpaces(softwareVersion);
  //       setSoftwareVersion(softwareVersion);
  //       formData.software_version = softwareVersion;
  //       setFormData(formData);
  //       break; 
  //     case 'mainBoardRev':
  //       let mainBoardRev = e.target.value;
  //       mainBoardRev = removeAllSpaces(mainBoardRev);
  //       setMainBoardRev(mainBoardRev);
  //       formData.main_board_rev = mainBoardRev;
  //       setFormData(formData);
  //       break;
  //     case 'custInfo':
  //       let custInfo = e.target.value;
  //       console.log("CustInfo::", custInfo);
  //       custInfo = removeAllSpaces(custInfo);
  //       setCustInfo(custInfo);
  //       if(formData){
  //         formData.customer_info = custInfo;
  //         setFormData(formData);
  //       }
  //       break;
  //     case 'soNumber':
  //       let soNumber = e.target.value;
  //       soNumber = removeAllSpaces(soNumber);
  //       setSoNum(soNumber);
  //       if(formData || formData.so_number !== ""){
  //         formData.so_number = soNumber;
  //         setFormData(formData);
  //       }
  //       break;
  //   }
  // }
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = removeAllSpaces(value);
    // console.log("CleanedValue:", cleanedValue);

    switch (name) {
      case 'probeNum':
        setProbeNum(cleanedValue);
        setFormData({ ...formData, serial_number: cleanedValue });
        break;
      case 'modelName':
        setModelName(cleanedValue);
        setFormData({ ...formData, model_name: cleanedValue });
        break;
      case 'macAddress':
        setMacAddress(cleanedValue);
        setFormData({ ...formData, mac_address: cleanedValue });
        break;
      case 'softwareVersion':
        setSoftwareVersion(cleanedValue);
        setFormData({ ...formData, software_version: cleanedValue });
        break;
      case 'mainBoardRev':
        setMainBoardRev(cleanedValue);
        setFormData({ ...formData, main_board_rev: cleanedValue });
        break;
      case 'custInfo':
        setCustInfo(cleanedValue);
        setFormData({ ...formData, customer_info: cleanedValue });
        break;
      case 'soNumber':
        setSoNum(cleanedValue);
        setFormData({ ...formData, so_number: cleanedValue });
        break;
      default:
        break;
    }
  };

  const handleModelChange = (e) => {
    const modelName = e.target.value;
    console.log("modelName:--->", modelName);
    setModelName(modelName);
    // setSelectedModel(modelName);
    const modelObj = probeModels.find(m => m.model_name === modelName)
    setSupportedTypes(modelObj.supported_probe_types || [])
    setFormData(prev => ({
      ...prev,
      model_name: modelName,
      probe_type: '' // Reset probe type
    }));
    // setFormData({ ...formData, model_name: modelName });

  };

  useEffect(() => {
    // console.log("probeModels:----------->", probeModels);
    // console.log("formData:--->", formData);
    // console.log("Probe types for the currently selected model:---", supportedTypes);

  }, [probeModels, formData])

  useEffect(() => {
    // if (probeModels.length > 0 && formData.model_name) {
    //   const modelObj = probeModels.find(
    //     m => m.model_name === formData.model_name
    //   )
    //   setSupportedTypes(modelObj.supported_probe_types || []);
    // }
    if (!formData.model_name) {
      setSupportedTypes([]);
      return;
    }

    const modelObj = probeModels.find(
      m => m.model_name === formData.model_name
    );
    //  setSupportedTypes(modelObj.supported_probe_types || []);
    if (modelObj && modelObj.supported_probe_types) {
      setSupportedTypes(modelObj.supported_probe_types);
    } else {
      setSupportedTypes([]);
    }
  }, [probeModels, formData])


  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      serial_number: probeNum || "",
      probe_type: probeType || "",
      model_name: modelName || "",
      so_number: soNumber || "",
      customer_info: custInfo || "",
      main_board_rev: mainBoardRev || "",
      software_version: softwareVersion || "",
      mac_address: macAddress || ""
    };
    // console.log(payload, formData);
    // if(isEditMode) {
    //   console.log("Before Modify::", formData.serial_number, formData);
    //   modifyProbe(formData.serial_number, formData)
    //   .then((result) => {
    //     console.log("ModifyProbe::", result);
    //     if(result != null) getProbeInventoryData();
    //   }).catch((error) => {
    //     console.log(error);
    //   });
    // } else {
    //   addProbe(probeNum, payload)
    //     .then((result) => {
    //       console.log("addProbe::", result);
    //       if(result != null) getProbeInventoryData();
    //     }).catch((error) => {
    //       console.log(error);
    //     });
    // }
    try {
      if (isEditMode) {
        // let result = await modifyProbe(formData.serial_number, formData);
        let result = await modifyProbe(formData.serial_number, payload);
        if (result.code === 200) {
          await getProbeInventoryData();
        } else { }
      } else {
        let result = await addProbe(probeNum, payload);
        if (result.code === 200) {
          await getProbeInventoryData();
        } else { }
      }
    } catch (error) {
      console.log(error);
    }

    handleUpdateCloseDialog();
  }

  const handleProbeTypeChange = (event) => {
    // setProbeType(event.target.value);
    // setSupportedTypes(event.target.value)
    // formData.probe_type = event.target.value;
    // setFormData(formData);

    const type = event.target.value
    setFormData(f => ({
      ...f,
      probe_type: type
    }))
  }

  const handleDeleteAlertClose = (event, reason) => {

    if (reason === 'clickaway') {
      return;
    }
    setAlertState({ ...alertState, openAlert: false });
    setShowDeleteAlert(false);
  }

  const handleConfirmClose = () => {
    setConfirmDeleteOpen(false);
    handleUpdateCloseDialog();
  };

  const handleDeleteProbeInventory = () => {
    let strMsg = "Are you sure you want to delete?";
    setDeleteMessageConfirm(strMsg);
    setDeleteMessageConfirmTitle("Delete selected");
    setConfirmDeleteOpen(true);
  };

  const handleDeleteYes = () => {
    setConfirmDeleteOpen(false);
    handleUpdateCloseDialog();
    console.log("formData::", formData);
    if (formData.serial_number != null) {
      deleteProbes(formData);
    }
    // resetMyFilters();
    // setSelectedProbes([]);
  }

  const handleDeleteNo = () => {
    setConfirmDeleteOpen(false);
    handleUpdateCloseDialog();
  };

  const deleteProbes = async (probesToDelete) => {
    let errorList = [];
    let deletedProbes = [];

    // for (let idx = 0; idx < selectedProbes.length; idx++) {
    //     let probeInfo = selectedProbes[idx];

    //     try {
    //     const result = await deleteProbe(probeInfo.serial_number);

    //     if (result.code !== 200) {
    //         probeInfo['error_msg'] = JSON.stringify(result);
    //         errorList.push(probeInfo);
    //     } else {
    //         deletedUsers.push(probeInfo);
    //     }
    //     } catch (error) {
    //     probeInfo['error_msg'] = error;
    //     errorList.push(probeInfo);
    //     }
    // }

    const probesArray = Array.isArray(probesToDelete) ? probesToDelete : [probesToDelete];

    for (const probe of probesArray) {
      try {
        if (!probe || !probe.serial_number) {
          throw new Error("Missing serial number");
        }

        const result = await deleteProbe(probe.serial_number);

        if (result.code !== 200) {
          errorList.push({
            ...probe,
            error_msg: result.message || JSON.stringify(result)
          });
        } else {
          deletedProbes.push(probe);
        }
      } catch (error) {
        errorList.push({
          ...probe,
          error_msg: error.message || "Unknown error"
        });
      }
    }

    // Call refresh only once
    // props.getProbeInventoryData();
    getProbeInventoryData();

    setShowDeleteAlert(true);
    if (errorList.length > 0) {
      console.error("Error: Probe List :", errorList);
      setPageAlertType("error");
      setDeleteAlertMsg(`Error: ${errorList.length} probe(s) were not deleted`);
    } else {
      setPageAlertType("success");
      setDeleteAlertMsg(`Success : ${deletedProbes.length} probe(s) were deleted`);
    }
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, }}>
        <Box sx={{ width: "100%", marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
            Search Probe :
          </Typography>
          <TextField
            required
            id={`txtFldProbeInfo`}
            name="probeInfo"
            type="search"
            text="number"
            value={probeSerialNum}
            onChange={handleChange}

            autoComplete="off"
            InputProps={{ readOnly: false, sx: { color: text.main } }}
            sx={{ width: 250, color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
            placeholder="Enter Probe Number"
            InputLabelProps={{ sx: { color: text.main }, }}
            error={error}
            helperText={error ? "Please enter digits only" : ""}
          />
          <Button variant="contained" sx={{ mr: 1 }} color="secondary" aria-label="Search" onClick={handleSearch}>Search</Button>
          <>
            {/* {isProbeFound ? <Button variant="contained" sx={{ mr: 1 }} color="secondary" aria-label="Add New Entry" onClick={handleAddNew}
            endIcon={<AddIcon sx={{ backgroundColor: secondary.main }} size="small" fullWidth/>}>Add New Entry</Button> : null } */}
            {hasSearched && !isProbeFound && probeSerialNum && (
              <Button
                variant="contained"
                sx={{ mr: 1 }}
                color="secondary"
                aria-label="Add New Entry"
                onClick={handleAddNew}
                endIcon={<AddIcon sx={{ backgroundColor: secondary.main }} size="small" />}
              >
                Add New Entry
              </Button>
            )}
          </>

          <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ ml: 2, fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
            Import file :
          </Typography>
          <Input
            required
            id={`txtFldImportFile`}
            name="importFile"
            type="file"
            ref={fileInputRef}
            accept=".xlsx"
            onChange={handleImportChage}
            autoComplete="off"
            InputProps={{ readOnly: false, sx: { color: text.main } }}
            sx={{ width: 250, color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
            placeholder="Enter Probe Number"
            InputLabelProps={{ sx: { color: text.main }, }}
          // error={error}
          // helperText={error ? "Please enter digits only" : ""}
          />
          <Button variant="contained" sx={{ mr: 1 }} color="secondary" aria-label="Search" onClick={handleImportFile}>Import</Button>
        </Box>
        {/* <Box sx={{ width: "80%", marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
              Import file :
          </Typography>
          <Input 
              required
              id={`txtFldImportFile`}
              name="importFile"
              type="file"                                
              ref={fileInputRef}
              accept=".xlsx"
              onChange={handleImportChage}
              autoComplete="off"                  
              InputProps={{  readOnly: false, sx: { color: text.main }}}                    
              sx={{ width: 300, color: text.main,  borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}                    
              placeholder="Enter Probe Number"
              InputLabelProps={{ sx: { color: text.main }, }}
              error={error}
              helperText={error ? "Please enter digits only" : ""}
            />
          <Button variant="contained" sx={{ mr: 1 }} color="secondary" aria-label="Search" onClick={handleImportFile}>Import</Button>
        </Box> */}
        <Grid container direction="row" spacing={2} justifyContent="center" display="flex" mt={0}>
          {/* <Grid item xs={12} sm={12} md={12} sx={{ mb: 0 }}>
              <Button variant="contained" sx={{ mr: 1 }} disabled={isProbeFound} color="secondary" aria-label="Add New Entry" onClick={handleAddNew}
                endIcon={<AddIcon sx={{ backgroundColor: secondary.main }} size="small" fullWidth/>}>Add New Entry</Button>
            </Grid> */}
          <Grid item xs={12} sm={12} md={12} >
            <Card>
              <CardContent sx={{ mt: 1, px: 0 }}>
                {/* {loading && !probeInventoryData ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 200,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : probeInventoryData && probeInventoryData.length > 0 ? (
                  <ProbeInventoryTable
                    probeInventoryData={probeInventoryData}
                    loading={loading}
                    getProbeInventoryData={getProbeInventoryData}
                    setFormData={setFormData}
                    setIsEditMode={setIsEditMode}
                    setOpenAddProbeDialog={setOpenAddProbeDialog}
                  />
                ) : (
                  <Box m={4} p={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>
                      No Probe Details
                    </Typography>
                  </Box>
                )} */}

                {/* {probeInventoryData && probeInventoryData.length > 0 ? (
                  <ProbeInventoryTable
                    probeInventoryData={probeInventoryData}
                    loading={loading}
                    getProbeInventoryData={getProbeInventoryData}
                    setFormData={setFormData}
                    setIsEditMode={setIsEditMode}
                    setOpenAddProbeDialog={setOpenAddProbeDialog}
                  />
                ) : (
                  <Box m={4} p={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>
                      No Probe Details
                    </Typography>
                  </Box>
                )} */}

                {loading && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                    <CircularProgress color="secondary" />
                  </Box>
                )}

                {!loading && probeInventoryData && probeInventoryData.length > 0 && (
                  <ProbeInventoryTable
                    probeInventoryData={probeInventoryData}
                    loading={loading}
                    getProbeInventoryData={getProbeInventoryData}
                    setFormData={setFormData}
                    setIsEditMode={setIsEditMode}
                    setOpenAddProbeDialog={setOpenAddProbeDialog} />
                )}

                {!loading && probeInventoryData && probeInventoryData.length === 0 && (
                  <Box m={4} p={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>
                      No Probe Details
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* {isSearching ?
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // maxWidth="lg"
              height: 200,
            }}>
              <CircularProgress color="secondary" />
            </Box>
            : */}
          <Dialog
            open={openAddProbeDialog}
            onClose={handleUpdateCloseDialog}
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{
              '& .MuiDialog-paper': {
                backgroundColor: primary.main,
              }
            }}
          >
            <form onSubmit={handleSubmit}>
              {/* <form> */}
              <DialogTitle>
                <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                  {isEditMode ? 'Probe' : 'Add Probe Entry'}
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2} direction="row">
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      Probe Type*
                    </Typography>
                    <Select
                      fullWidth
                      sx={{
                        // width: 300,
                        '.MuiSelect-select': {
                          paddingTop: '8px !important',
                          paddingBottom: '8px !important',
                          minHeight: '35px !important',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '1em !important'
                        },
                      }}
                      name="probe_type"
                      // value={probeType}
                      // value={formData ? formData.probe_type : probeType}
                      value={formData ? formData.probe_type : supportedTypes[0]}
                      // value={supportedTypes}
                      // value={formData.probe_type}
                      displayEmpty
                      onChange={handleProbeTypeChange}
                    >
                      {supportedTypes.length > 0 ? (
                        supportedTypes.map((type, index) => (
                          <MenuItem key={`${type}-${index}`} value={type}>
                            {type}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="" disabled>
                          {formData.probe_type ? 'No types available' : 'Select model first'}
                        </MenuItem>
                      )}
                    </Select>
                  </Grid>

                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      Serial Number*
                    </Typography>
                    <TextField
                      required
                      id='probeNum'
                      name='probeNum'
                      placeholder='Serial Number'
                      value={formData != null ? formData.serial_number : probeNum}
                      // type={number}
                      fullWidth
                      onChange={handleFormChange}
                      focused={isEditMode ? true : false}
                      disabled={isEditMode ? true : false}
                      sx={{
                        // width: 200,
                        color: text.main,
                        borderColor: primary.focus,
                        backgroundColor: transparent.main,
                        borderRadius: borderRadius.md,
                      }}
                    />
                  </Grid>

                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      Model Name*
                    </Typography>

                    {/* <TextField
                        id="modelName"
                        name="modelName"
                        placeholder="Model Name"
                        value={formData ? formData.model_name : modelName}
                        fullWidth
                        focused
                        // onChange={handleFormChange}
                        // onChange = {handleModelChange}
                        sx={{
                          // width: 200,
                          color: text.main,
                          borderColor: primary.focus,
                          backgroundColor: transparent.main,
                          borderRadius: borderRadius.md,
                        }}
                      /> */}

                    <Select
                      fullWidth
                      sx={{
                        // width: 300,
                        '.MuiSelect-select': {
                          paddingTop: '8px !important',
                          paddingBottom: '8px !important',
                          minHeight: '35px !important',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '1em !important'
                        },
                      }}
                      // value={formData.model_name || ''}
                      // onChange={handleFormChange}
                      displayEmpty
                      value={formData ? formData.model_name : modelName}
                      onChange={handleModelChange}
                      label="Model Name"
                      required
                    >
                      <MenuItem value="" disabled>
                        {probeModels.length ? 'iVAM2-2' : 'Select model'}
                      </MenuItem>

                      {probeModels.map((model) => (
                        <MenuItem key={model.id} value={model.model_name}>
                          {model.model_name}
                        </MenuItem>
                      ))}

                    </Select>

                  </Grid>
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      MAC Address
                    </Typography>

                    <TextField
                      id="macAddress"
                      name="macAddress"
                      placeholder="MAC Address"
                      value={formData != null ? formData.mac_address : macAddress}
                      fullWidth
                      focused
                      onChange={handleFormChange}
                      sx={{
                        // width: 200,
                        color: text.main,
                        borderColor: primary.focus,
                        backgroundColor: transparent.main,
                        borderRadius: borderRadius.md,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      Software Version
                    </Typography>

                    <TextField
                      id="softwareVersion"
                      name="softwareVersion"
                      placeholder="Software Version"
                      value={formData != null ? formData.software_version : softwareVersion}
                      fullWidth
                      focused
                      onChange={handleFormChange}
                      sx={{
                        // width: 200,
                        color: text.main,
                        borderColor: primary.focus,
                        backgroundColor: transparent.main,
                        borderRadius: borderRadius.md,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      Main board Revolution
                    </Typography>

                    <TextField
                      id="mainBoardRev"
                      name="mainBoardRev"
                      placeholder="Main board Revolution"
                      value={formData != null ? formData.main_board_rev : mainBoardRev}
                      fullWidth
                      focused
                      onChange={handleFormChange}
                      sx={{
                        // width: 200,
                        color: text.main,
                        borderColor: primary.focus,
                        backgroundColor: transparent.main,
                        borderRadius: borderRadius.md,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      Customer Info
                    </Typography>

                    <TextField
                      id="custInfo"
                      name="custInfo"
                      placeholder="Customer Info"
                      value={formData ? formData.customer_info : custInfo}
                      fullWidth
                      focused
                      onChange={handleFormChange}
                      sx={{
                        // width: 200,
                        color: text.main,
                        borderColor: primary.focus,
                        backgroundColor: transparent.main,
                        borderRadius: borderRadius.md,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                      SO Number
                    </Typography>

                    <TextField
                      id="soNumber"
                      name="soNumber"
                      placeholder="SO Number"
                      value={formData != null ? formData.so_number : soNumber}
                      fullWidth
                      focused
                      onChange={handleFormChange}
                      sx={{
                        // width: 200,
                        color: text.main,
                        borderColor: primary.focus,
                        backgroundColor: transparent.main,
                        borderRadius: borderRadius.md,
                      }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleUpdateCloseDialog} color="secondary" variant="contained">
                  Cancel
                </Button>
                {isEditMode && (
                  <>
                    <Button onClick={handleDeleteProbeInventory} color="secondary" variant="contained">
                      Delete
                    </Button>
                  </>
                )}
                <Button type="submit" color="secondary" variant="contained">
                  {isEditMode ? 'Update' : 'Add'}
                </Button>
              </DialogActions>
            </form>
          </Dialog>
          {/* } */}

          <Dialog open={confirmDeleteOpen} onClose={handleConfirmClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth='md'
            sx={{
              '& .MuiDialog-paper': {
                backgroundColor: primary.main,
              }
            }}
          >
            <DialogTitle id="alert-dialog-title">
              <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{deleteMessageConfirmTitle}</Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{deleteMessageConfirm}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
                onClick={handleDeleteNo}>No</Button>

              <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
                onClick={handleDeleteYes} autoFocus>Yes</Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={showDeleteAlert}
            autoHideDuration={6000}
            key={vertical + horizontal}
            onClose={handleDeleteAlertClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleDeleteAlertClose}
              severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message": { color: white.main, fontSize: size.sm }, marginBottom: 4 }}
            >
              {deleteAlertMsg}
            </Alert>
          </Snackbar>
        </Grid>
      </Box>
    </>
  );
}
